import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_do_workers_confirm_accuracy_payouts_re_payments'

export const dataPointDefinition = {
  retracedId: 'yes_do_workers_confirm_accuracy_payouts_re_payments',
  name: 'If yes, do workers confirm the accuracy of payouts and re-payments in writing?',
  description:
    'The intent of this question is to understand if there is some kind of written evidence from workers that confirms the initial advance or loan amount given and (if applicable) written evidence that confirms repayment installment amounts from the worker back to the facility, etc. ',
  meta: {
    slcpMeta: {
      key: 'wb-17--4',
      number: 'WB-WAGE-117',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-17--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35140,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
